<template>
  <div class="main-validation" ref="validationContainer">
    <header-customer-component
      :customerPhoneNumber="customerPhoneNumber"
      :rejectDone="rejectDone"
      :approveDone="approveDone"
      :pixData="pixData"
      :seller="seller"
      @emitApproveOpen="emitApproveOpen"
      @emitRejectOpen="emitRejectOpen"
      @emit-order-status="getOrderStatus"
      @emit-order-transaction-status="getOrderTransactionStatus"
      @emit-customer-steps="getCustomerSteps"
    />
    <section id="order-validation" class="order-validation"  v-resize="handleResize">
      <div class="content-client" :class="this.validationResize < 1075 ? 'col-md-6' : 'col-md-5'">
        <customer-data-component
          :cpfStatus="cpfStatus"
          :check="check"
          :isUpdateCustomerData="isUpdateCustomerData"
          :socialName="socialName"
          @emitWhastappOpen="emitWhastappOpen"
          @emitWhatsappScrollbar="emitWhatsappScrollbar"
          @emit-customer-phone-number="getCustomerPhoneNumber"
          @emit-customer-name="getCustomerName"
          @emit-customer-cpf="getCustomerCpf"
          @emit-customer-profile-picture="getCustomerProfilePicture"
          @emit-customer-device="getCustomerDevice"
          @emitContactOpen="emitContactOpen"
        />
        <hr />
        <customer-address-component
          :addressStatus="addressStatus"
          :check="check"
        />
        <hr />
        <customer-list-installments-component
          v-if="orderTransactionStatus === 'Aprovado - Pagamentos Pendentes'"
          @emit-next-installment="getNextInstallment($event)"
          @emit-total-installments="getTotalInstallments($event)"
        />
        <hr v-if="orderTransactionStatus === 'Aprovado - Pagamentos Pendentes'"/>
        <order-historic-component />
      </div>
      <div class="content-automation" :class="this.validationResize < 1075 ? 'col-md-6' : 'col-md-7'">
        <customer-pix-component
          :orderTransactionStatus="orderTransactionStatus"
          @emit-pix-data="getPixData($event)"
        />
        <verify-customer-component
          :resizeClass="resizeClass"
          :customerPhoneNumber="customerPhoneNumber"
          :customerName="customerName"
          :customerSteps="customerSteps"
          :seller="seller"
          :loadingLink="loadingLink"
          @backgroundCheckStatus="getBackgroundCheckStatus($event)"
          @addressCheckStatus="getAddressCheckStatus($event)"
          @emitWhastappOpen="emitWhastappOpen"
          @emitWhatsappScrollbar="emitWhatsappScrollbar"
          @emit-split-message="getSplitMessage($event)"
        />
        <order-data-component
          :resizeClass="resizeClass"
          @emit-seller="getSeller($event)"
          @emit-reference="getReference($event)"
        />
        <timeline-component
          :resizeClass="resizeClass"
          @check="getCheck($event)"
          @emit-customer-social-name="getSocialName"
        />
      </div>
    </section>
    <whatsapp-customer-component
      v-if="whatsappOpen"
      :whatsappScrollbar="whatsappScrollbar"
      :customerName="customerName"
      :customerProfilePicture="customerProfilePicture"
      :splitMessage="splitMessage"
      :seller="seller"
      :reference="reference"
      :totalInstallments="totalInstallments"
      :nextInstallment="nextInstallment"
      @emitWhastappClose="emitWhastappClose"
      @emitContactOpen="emitContactOpen"
      @emit-clean-next-installment="getCleanNextInstallment"
      @emit-loading='getLoading'
    />
    <reject-request-component
      v-if="rejectOpen"
      :customerPhoneNumber="customerPhoneNumber"
      :customerDevice="customerDevice"
      :customerCpf="customerCpf"
      @emitRejectClose="emitRejectClose"
      @emit-reject-done="getRejectStatus"
    />
    <approve-request-component
      v-if="approveOpen"
      :orderStatus="orderStatus"
      :customerPhoneNumber="customerPhoneNumber"
      @emitApproveClose="emitApproveClose"
      @emit-approve-done="getApproveStatus"
    />
    <contact-request-component
      v-if="contactOpen"
      @emitContactClose="emitContactClose"
      @emit-update-customer-data="updateCustomerData"
    />
  </div>
</template>

<script>
import CustomerData from '../../partial/customer/CustomerData'
import CustomerAddress from '../../partial/customer/CustomerAddress'
import OrderHistoric from '../../partial/customer/OrderHistoric'
import CustomerListInstallments from '../../partial/customer/CustomerListInstallments'
import VerifyCustomer from '../../partial/customer/VerifyCustomer'
import CustomerPix from '../../partial/customer/CustomerPix'
import HeaderCustomer from '../../partial/customer/HeaderCustomer'
import OrderData from '../../partial/customer/OrderData'
import Timeline from '../../partial/customer/Timeline'
import WhatsappCustomer from '../../partial/customer/WhatsappCustomer'
import RejectRequest from '../../partial/customer/RejectRequest'
import ApproveRequest from '../../partial/customer/ApproveRequest'
import ContactRequest from '../../partial/customer/ContactRequest.vue'
import resize from 'vue-resize-directive'

export default {
  directives: {
    resize
  },
  components: {
    'customer-data-component': CustomerData,
    'customer-address-component': CustomerAddress,
    'order-historic-component': OrderHistoric,
    'customer-list-installments-component': CustomerListInstallments,
    'verify-customer-component': VerifyCustomer,
    'header-customer-component': HeaderCustomer,
    'order-data-component': OrderData,
    'timeline-component': Timeline,
    'whatsapp-customer-component': WhatsappCustomer,
    'reject-request-component': RejectRequest,
    'approve-request-component': ApproveRequest,
    'contact-request-component': ContactRequest,
    'customer-pix-component': CustomerPix
  },
  mounted () {
  },
  data () {
    return {
      validationResize: null,
      resizeClass: null,
      testValue: null,
      cpfStatus: null,
      addressStatus: null,
      customerPhoneNumber: null,
      customerName: null,
      customerCpf: null,
      customerProfilePicture: null,
      customerDevice: null,
      whatsappOpen: false,
      whatsappScrollbar: false,
      rejectOpen: false,
      rejectDone: false,
      approveDone: false,
      approveOpen: false,
      contactOpen: false,
      orderStatus: null,
      orderTransactionStatus: null,
      splitMessage: null,
      seller: null,
      reference: null,
      nextInstallment: null,
      totalInstallments: null,
      pixData: null,
      check: null,
      isUpdateCustomerData: false,
      socialName: null,
      customerSteps: null,
      loadingLink: null
    }
  },
  methods: {
    getCleanNextInstallment () {
      this.nextInstallment = ''
    },
    updateCustomerData (e) {
      this.isUpdateCustomerData = e
      setTimeout(() => {
        this.isUpdateCustomerData = false
      }, 1000)
    },
    getPixData (e) {
      this.pixData = e
    },
    getTotalInstallments (e) {
      this.totalInstallments = e
    },
    getNextInstallment (e) {
      this.nextInstallment = e
    },
    getSeller (e) {
      this.seller = e
    },
    getReference (e) {
      this.reference = e
    },
    getSplitMessage (e) {
      console.log(e)
      this.splitMessage = e
    },
    getOrderTransactionStatus (e) {
      this.orderTransactionStatus = e
    },
    getApproveStatus (e) {
      this.approveDone = e
    },
    getOrderStatus (e) {
      this.orderStatus = e
    },
    getRejectStatus (e) {
      this.rejectDone = e
    },
    getCustomerCpf (e) {
      this.customerCpf = e
    },
    getCustomerDevice (e) {
      this.customerDevice = e
    },
    getCustomerProfilePicture (e) {
      this.customerProfilePicture = e
    },
    getCustomerName (e) {
      this.customerName = e
    },
    getCustomerPhoneNumber (e) {
      this.customerPhoneNumber = e
    },
    getBackgroundCheckStatus (e) {
      this.cpfStatus = e
    },
    getAddressCheckStatus (e) {
      this.addressStatus = e
    },
    getCheck (e) {
      this.check = e
    },
    getSocialName (e) {
      this.socialName = e
    },
    getCustomerSteps (e) {
      this.customerSteps = e
    },
    getLoading (e) {
      this.loadingLink = e
    },
    handleResize () {
      this.validationResize = this.$refs.validationContainer.clientWidth
      if (this.validationResize < 1280) {
        this.resizeClass = 'col-md-12'
      } else {
        this.resizeClass = 'col-md-6'
      }
    },
    emitWhatsappScrollbar () {
      this.whatsappScrollbar = !this.whatsappScrollbar
    },
    emitWhastappOpen () {
      if (this.splitMessage) {
        this.whatsappOpen = true
      } else {
        this.whatsappOpen = !this.whatsappOpen
      }

      this.rejectOpen = false
      this.approveOpen = false
      this.contactOpen = false
      if (this.whatsappOpen) {
        document.getElementById('order-validation').style.maxWidth = '70%'
      } else {
        document.getElementById('order-validation').style.maxWidth = '100%'
      }
    },
    emitWhastappClose () {
      this.whatsappOpen = false
      document.getElementById('order-validation').style.maxWidth = '100%'
    },
    emitRejectOpen () {
      this.rejectOpen = !this.rejectOpen
      this.whatsappOpen = false
      this.approveOpen = false
      this.contactOpen = false
      if (this.rejectOpen) {
        document.getElementById('order-validation').style.maxWidth = '70%'
      } else {
        document.getElementById('order-validation').style.maxWidth = '100%'
      }
    },
    emitRejectClose () {
      this.rejectOpen = false
      document.getElementById('order-validation').style.maxWidth = '100%'
    },
    emitApproveOpen () {
      this.approveOpen = !this.approveOpen
      this.whatsappOpen = false
      this.rejectOpen = false
      this.contactOpen = false
      if (this.approveOpen) {
        document.getElementById('order-validation').style.maxWidth = '70%'
      } else {
        document.getElementById('order-validation').style.maxWidth = '100%'
      }
    },
    emitApproveClose () {
      this.approveOpen = false
      document.getElementById('order-validation').style.maxWidth = '100%'
    },
    emitContactOpen () {
      this.contactOpen = !this.contactOpen
      this.approveOpen = false
      this.whatsappOpen = false
      this.rejectOpen = false
      if (this.contactOpen) {
        document.getElementById('order-validation').style.maxWidth = '70%'
      } else {
        document.getElementById('order-validation').style.maxWidth = '100%'
      }
    },
    emitContactClose () {
      this.contactOpen = false
      document.getElementById('order-validation').style.maxWidth = '100%'
    }
  },
  watch: {
    '$route.params.txid' () {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/scss/order-validation.scss';

</style>



// WEBPACK FOOTER //
// src/components/pages/order/OrderValidation.vue